import { useState } from "react";
import { http, formatApiErrorDetail } from "../lib/api";

export default function NewsletterCTA({ source = "footer", variant = "block" }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | done | error
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    try {
      await http.post("/subscribe", { email: email.trim(), name: name.trim(), source });
      setStatus("done");
      setEmail("");
      setName("");
    } catch (err) {
      setStatus("error");
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  if (variant === "inline") {
    return (
      <div className="border-y-2 border-double border-ink py-6 my-10" data-testid={`newsletter-${source}`}>
        <p className="section-eyebrow text-center">Briefing diario · POLÍTICA REAL</p>
        <h3 className="font-serif-display text-3xl sm:text-4xl text-center mt-2 leading-tight">
          La política mexicana <span className="italic text-rojo">en 5 minutos</span>, cada mañana.
        </h3>
        <p className="text-center text-sub text-sm mt-2 max-w-xl mx-auto">
          Las notas que mueven la agenda nacional, opinión curada y el promedio de encuestas — directo en tu correo.
        </p>
        <form onSubmit={submit} className="mt-5 flex flex-col sm:flex-row gap-2 max-w-2xl mx-auto" data-testid={`newsletter-form-${source}`}>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Tu correo electrónico"
            className="flex-1 bg-transparent border border-ink/40 focus:border-ink outline-none px-3 py-2 font-sans text-sm rounded-none"
            data-testid={`newsletter-email-${source}`}
          />
          <button
            type="submit"
            disabled={status === "sending" || status === "done"}
            className="border border-ink bg-ink text-paper px-6 py-2 font-mono text-[12px] uppercase tracking-widest hover:bg-rojo hover:border-rojo transition-colors disabled:opacity-40"
            data-testid={`newsletter-submit-${source}`}
          >
            {status === "sending" ? "Suscribiendo…" : status === "done" ? "✓ Listo" : "Suscribirme"}
          </button>
        </form>
        {status === "done" && (
          <p className="text-center text-sm text-verde mt-3 font-mono uppercase tracking-widest">
            Te avisaremos al lanzar el primer briefing.
          </p>
        )}
        {error && <p className="text-center text-sm text-rojo mt-3">{error}</p>}
      </div>
    );
  }

  // Footer variant
  return (
    <div className="border border-ink p-4 bg-paper" data-testid={`newsletter-${source}`}>
      <p className="section-eyebrow">Briefing Diario</p>
      <p className="font-serif-display text-2xl mt-1 leading-tight">
        Recibe lo esencial de la política mexicana cada mañana.
      </p>
      <form onSubmit={submit} className="mt-3 space-y-2" data-testid={`newsletter-form-${source}`}>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nombre (opcional)"
          maxLength={80}
          className="w-full bg-transparent border border-ink/30 focus:border-ink outline-none px-3 py-2 font-sans text-sm rounded-none"
        />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="correo@ejemplo.com"
          className="w-full bg-transparent border border-ink/30 focus:border-ink outline-none px-3 py-2 font-sans text-sm rounded-none"
          data-testid={`newsletter-email-${source}`}
        />
        <button
          type="submit"
          disabled={status === "sending" || status === "done"}
          className="w-full border border-ink bg-ink text-paper py-2 font-mono text-[11px] uppercase tracking-widest hover:bg-rojo hover:border-rojo transition-colors disabled:opacity-40"
          data-testid={`newsletter-submit-${source}`}
        >
          {status === "sending" ? "Suscribiendo…" : status === "done" ? "✓ Suscrito" : "Suscribirme"}
        </button>
      </form>
      {status === "done" && (
        <p className="text-xs text-verde mt-2">Bienvenido. Te escribiremos pronto.</p>
      )}
      {error && <p className="text-xs text-rojo mt-2">{error}</p>}
    </div>
  );
}
